import { makeStyles } from '@fluentui/react';
const RED_700 = '#D32F2F';
const RED_800 = '#C62828';
const RED_900 = '#B71C1C';
export const useStyles = makeStyles((theme) => ({
  neutralLighterAlt: {
    color: theme.palette.neutralLighterAlt,
  },
 
 
  
  footerStyle: {
    backgroundColor: theme.palette.neutralLighterAlt,
    boxShadow: `-1px -4px 13px rgba(0, 0, 0, 0.15)`,
  },
  footerBackground: {
    backgroundColor: theme.palette.neutralLighterAlt,
  },

  tagsContainer: {
    marginTop: 20,
    paddingLeft: 25,
    paddingRight: 25,
    marginBottom: 20,
  },
  footerContainer: {
    position: 'sticky',
    bottom: 0,
    zIndex: 1,
  },
  declineButton: {
    color: 'white',
    backgroundColor: RED_700,
    borderColor: RED_700,
    borderStyle: 'solid',
    borderWidth: 1,
    ':hover': {
      color: 'white',
      backgroundColor: RED_800,
      borderColor: RED_800,
    },
    ':active': {
      color: 'white',
      backgroundColor: RED_900,
      borderColor: RED_900,
    },
  },
    disabledButton: {
    ':disabled': {
      backgroundColor: `${theme.palette.neutralQuaternaryAlt} !important`,
      borderColor: `${theme.palette.neutralQuaternaryAlt} !important`,
      color: `${theme.palette.neutralTertiary} !important`,
    },
    '&.is-disabled': {
      backgroundColor: `${theme.palette.neutralQuaternaryAlt} !important`,
      borderColor: `${theme.palette.neutralQuaternaryAlt} !important`,
      color: `${theme.palette.neutralTertiary} !important`,
    },
  },
}));
